import { render, staticRenderFns } from "./VinventoryIndex.vue?vue&type=template&id=0463e92f"
import script from "./VinventoryIndex.vue?vue&type=script&lang=js"
export * from "./VinventoryIndex.vue?vue&type=script&lang=js"
import style0 from "./VinventoryIndex.vue?vue&type=style&index=0&id=0463e92f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports